import React from 'react'

const LogoHeader = ({register}) => {
  return (
    <div className='mt-3'>
        <img
          src="images/logo.png"
          alt="Logo"
          className="mx-auto block w-[100px] sm:w-[90px] md:w-1/5 lg:w-1/5"
        />
        {/* {!register && <h2
          className="text-center text-white text-6xl sm:text-7xl md:text-8xl lg:text-8xl mt-5 font-bold"
          style={{
            fontFamily: "'Kalam', sans-serif",
            textShadow:
              "-1px -1px 0 #c36e00, 1px -1px 0 #c36e00, -1px 1px 0 #c36e00, 1px 1px 0 #c36e00",
          }}
        >
          Welcome
        </h2>} */}
         <div className="flex justify-center items-center mt-4">
          <img
          src="images/logo2.png"
          alt="Logo"
          className="w-64 h-36"
        />
        </div>
      </div>
  )
}

export default LogoHeader